import './pagination';
import './progress_circle/progress_circle';
import './share_link_by_email';
import { commonUtils } from './common_utils';
import { adReview } from './ad_review';
import { reviewImageSlider } from './review_image_slider';

$(function() {
    let $body = $('body');
    let currentPage = $('#getReviewData').data('current-page') || '';

    // image slider on review images
    reviewImageSlider.init();

    // On click Facebook share from Share ad
    $body.on('click', '.shareUrlToFacebook', function() {
        commonUtils.dataLayer.shareButtonDataLayerEvent('Facebook');
    });

    // On click Twitter share from Share ad
    $body.on('click', '.shareUrlToTwitter', function() {
        commonUtils.openNewWindow($(this).data('twitter-share-url'), 660, 430, '', 250, 200);
        commonUtils.dataLayer.shareButtonDataLayerEvent('Twitter');
    });

    // fetch review models for selected make.
    $body.on('change', '#searchByMake', function() {
        $('#searchByModel').prop('disabled', true);
        adReview.getModelList('review_model_list_by_make', $('#searchByMake').val(), 'searchByModel');
    });

    // Sort by options
    $body.on('change', '#sortByCategory', function() {
        $('#formSortingCategory').submit();
    });

    // fetch all model for selected make
    $body.on('change', '#reviewMakeModal', function() {
        $('#reviewModelModal').prop('disabled', true);
        adReview.getModelList('options_get_model_by_make', $('#reviewMakeModal').val(), 'reviewModelModal');
    });

    // load more vehicle models on main & make page.
    $body.on('click', '.loadMoreVehicleModels', function() {
        adReview.loadMoreVehicleModels();
        $('#loadMoreDiv').remove();
    });

    // load more reviews on review-model page.
    $body.on('click', '.loadMoreModelReviews', function() {
        adReview.loadMoreModelReviews();
        $('#loadMoreReviewsDiv').remove();
    });

    // Create review modal
    $body.on('click', '.makeReviewModal', function() {
        adReview.createReviewModal();
    });

    // Read more/less review comment
    $body.on('click', '.readMoreReviewComment', function() {
        adReview.showHideComment($(this).data('review-id'));
    });

    // save user's like/dis-like on review comment
    $body.on('click', '.saveReviewLike', function() {
        adReview.saveUserOpinionOnReviewComment($(this));
    });

    $body.on('click', '#startReview', function() {
        adReview.startReview();
    });

    // Make-Model page redirection.
    $body.on('click', '#goToMakeOrModelPage', function() {
        adReview.searchByMakeModel();
    });

    // redirect to selected-make review listing page
    $body.on('change', '#selectVehicleMake', function() {
        let make = $(this).find(':selected').data('url-string');
        adReview.redirectReviewListing(make, '');
    });

    // redirect to selected-make+model review listing page
    $body.on('change', '#selectVehicleMakeModel', function() {
        let make = $(this).find(':selected').data('make');
        let model = $(this).find(':selected').data('model');
        adReview.redirectReviewListing(make, model);
    });

    // change the end-Year, when start-year selected
    $body.on('change', '#startYear', function() {
        commonUtils.changeFromToOptions(this, this.form.endYear, '', 'desc');
    });

    // show circle bar on make+model page images.
    if (currentPage === 'model') {
        adReview.showCircleBar();
    }

    // fetch the articles related to make or make+model page.
    setTimeout(function() {
        if (currentPage) {
            adReview.getArticleList(currentPage);
        }
    }, adReview.loadArticleTimeout);

    // search reviews by make-model
    $body.on('click', '#searchMakeModelLink', function() {
        $('.searchMakeModel').toggle();
    });

    // Sort by newest or top liked reviews
    $body.on('change', '#sortModelReview, #startYear, #endYear', function() {
        $('#formReviewSearch').submit();
    });
});
